import { createReducer, on } from '@ngrx/store';
import * as FaqStoreActions from './faq-store.actions';
import { FaqGroup } from '../models/faq-group';

export const faqStoreFeatureKey = 'faqStore';

export interface State {
    faqs?: FaqGroup[];
    filterValue?: string
}

export const initialState: State = {
    faqs: [],
};

export const reducer = createReducer(
    initialState,

    on(FaqStoreActions.loadFaqStores, (state) => state),
    on(FaqStoreActions.loadFaqStoresSuccess, (state, action) => {
        return { ...state, faqs: action.data };
    }),
    on(FaqStoreActions.setFilterValue, (state, action) => {
        return { ...state, filterValue: action.data };
    })
);
